import { useContext, useEffect, useState } from 'react';
import { useMutation } from '@apollo/client/react';

import DeleteModal from '@atom/components/common/DeleteModal';
import TeamErrorModal from '@atom/components/common/teamErrorModal/TeamErrorModal';
import UserContext from '@atom/components/userDetail/UserContext';
import { DELETE_USER_BUDGET } from '@atom/graph/user';
import { Progress } from '@atom/mui';
import { getErrorCode } from '@atom/utilities/validationUtilities';

import classes from './budgetsTab.module.css';

export interface Props {
  open: boolean;
  onClose: () => void;
  budgetId: string;
}

const DeleteBudgetModal = ({ open, onClose, budgetId }: Props) => {
  const { user } = useContext(UserContext);
  const [errorOpen, setErrorOpen] = useState<boolean>(false);

  const [deleteBudget, { loading, error }] = useMutation(DELETE_USER_BUDGET);

  const confirm = () => {
    deleteBudget({
      variables: {
        input: {
          id: budgetId,
          userId: user.id,
        },
      },
    });

    onClose();
  };

  useEffect(() => {
    if (error) {
      const statusCode = getErrorCode(error);

      if (statusCode === 422) {
        setErrorOpen(true);
      }
    }
  }, [error]);

  return (
    <>
      <DeleteModal
        title="Delete Budget?"
        onConfirm={confirm}
        onCancel={onClose}
        open={open}
        content={
          loading ? (
            <Progress />
          ) : (
            <div className={classes.modalContainer}>
              Are you sure you want to remove this budget?
            </div>
          )
        }
      />
      <TeamErrorModal
        open={errorOpen}
        onClose={() => setErrorOpen(false)}
        type="budget"
      />
    </>
  );
};

export default DeleteBudgetModal;
